import React from "react";
import Design from "../../../../optics/components/drawers/templates/features/panel-advanced/designs/Design";
import { usePanelAdvancedStore } from "../../../../stores/use-panel-advanced-store";
import { PanelAdvancedEditorContainer } from "./styles";

const PanelAdvancedEditor = () => {
  const { data, selectedTab, setSelectedTab } = usePanelAdvancedStore(
    (state) => ({
      data: state.data,
      selectedTab: state.selectedTab,
      setSelectedTab: state.setSelectedTab,
    })
  );

  return (
    <PanelAdvancedEditorContainer>
      <Design data={data} tab={{ selectedTab, setSelectedTab }} isPreview />
    </PanelAdvancedEditorContainer>
  );
};

export default PanelAdvancedEditor;
